<template>
    <div class="hello">
        <template v-if="list.length">
            <div class="list-box" v-for="(ele) in list" :key="ele.bannerId">
                <div class="bg_img">
                    <img :src="generalImg" alt="">
                </div>
                <div :class="['leaderboard-card', changeBanner === ele.bannerId && ele.bannerType !== 'poster' && ele.bannerType !== 'pk'  ? 'leaderboard-card-change'
          : 'hide']">
                    <div class="fullscreen-btn" @click="screenfull">
                        <i :class="['fas', isScreenfull ? 'fa-compress' : 'fa-expand']"></i>
                    </div>

                    <div :class="['card-header', `card-header${headerCol}`]">
                        <div class="card-title">
                            <!--                            <i class="fas fa-chart-line"></i>-->
                            <span>
                {{ `${hanldValue(ele, 'platform_info.name')}${salaMap[hanldValue(ele, 'bannerType', 'err')]}` }}
              </span>
                        </div>
                    </div>
                    <div class="timer-indicator">
                        {{ `${currCountdown}秒后切换` }}
                    </div>

                    <div class="leaderboard-list" :ref="'scrollRef' + ele.bannerId">
                        <template v-if="hanldValue(ele, 'platform_sale_rank_data', []).length">
                            <div class="leaderboard-item" v-for="(item, ind) in ele.platform_sale_rank_data"
                                 :key="item.user_id">
                                <div :class="['rank', `rank-${ind + 1}`]">{{ ind + 1 }}</div>
                                <div class="avatar-container">
                                    <div class="avatar">
                                        <img
                                            :src="hanldValue(item, 'user_info.avatar_url_abs') || getAvatarPlaceholder()"
                                            alt="">
                                    </div>
                                    <div class="user-name">{{ hanldValue(item, 'user_info.name') }}</div>
                                </div>
                                <div class="user-info">
                                    <div class="data-stats-container">
                                        <div class="stat-item">
                                            <div class="stat-label">{{ hanldValue(ele, 'beforeYesterday') }}</div>
                                            <div class="stat-value">
                                                {{
                                                    hanldMonely(item.day_before_yesterday_sale_data, ele.rank_config.method_type)
                                                }}
                                            </div>

                                        </div>

                                        <div class="stat-item">
                                            <div class="stat-label">{{ hanldValue(ele, 'yesterday') }}</div>
                                            <div class="stat-value medium-low">
                                                {{ hanldMonely(item.yesterday_data, ele.rank_config.method_type) }}
                                            </div>
                                        </div>

                                        <div class="stat-item average-item">
                                            <div class="stat-label">
                                                {{ hanldTitle(ele.bannerType, ele.rank_config.method_type) }}
                                            </div>
                                            <div class="stat-value">
                                                {{ hanldMonely(item.total_data, ele.rank_config.method_type) }}
                                            </div>
                                        </div>

                                        <div class="stat-item" v-if="ele.bannerType === 'sale_after'">
                                            <div class="stat-label">{{ '激励金额' }}</div>
                                            <div class="stat-value medium-low">
                                                {{ hanldValue(item, "reward_money") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="empty-message" v-else>
                            <i class="fas fa-database"></i>
                            暂无数据
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="update-time">{{ `更新时间：${uploadTime}` }}</div>
                    </div>

                    <div class="category-indicator">
                        <div :class="['category-dot', changeBanner === i ? 'active' : '']" v-for="(element, i) in list"
                             :key="i"
                             @click="changeBan(element)"></div>
                    </div>
                </div>

                <div
                    :class="['poster', changeBanner === ele.bannerId && ele.bannerType === 'poster' ? 'leaderboard-card-change' : 'hide']">
                    <div class="bg-img-box">
                        <img :src="hanldValue(ele, 'background_url_abs')" alt="">
                    </div>
                    <div class="poster-content">
                        <div class="left-box">
                            <div class="group-box">
                                <img src="../assets/sui-l.png" alt="">
                                <div class="group">
                                    {{
                                        `${hanldValue(ele, 'platform_info.name')}${ele.job_type === 1 ? '售前' : '售后'}`
                                    }}
                                </div>
                                <img src="../assets/sui-r.png" alt="">
                            </div>
                            <div class="tips">特发喜报 望再创佳绩</div>
                        </div>
                        <div class="right-box">
                            <div class="title-box">
                                {{ `· ${hanldDate(ele.start_date, ele.job_type, ele.rank_type)} ·` }}
                            </div>
                            <div class="show-data">{{
                                    `${hanldValue(ele, 'start_date')}~${hanldValue(ele, 'end_date')}`
                                }}
                            </div>
                            <div :class="[ele.rank?.length > 3 ? 'award-list-all' : 'award-list',
                            { 'no-scroll': changeBanner === ele.bannerId && ele.bannerType === 'poster' && !isAutoScroll }]"
                                 :ref="'scrollRefPoster' + ele.bannerId"
                            >
                                <div class="award-item" v-for="(item, index) in ele.rank" :key="item.user_id">
                                    <div class="profile-box">
                                        <div class="profile-img">
                                            <div class="img-box">
                                                <img :src="item.user_info?.avatar_url_abs" alt="">
                                            </div>
                                        </div>
                                        <div :class="['rank-box', 'rank-color', `rank-color${index + 1}`]">
                                            {{ hanldRank(index) }}
                                        </div>
                                    </div>
                                    <div class="info">
                                        <div class="name">{{ hanldValue(item, 'user_info.name') }}</div>
                                        <div class="line"></div>
                                        <div class="money-box">
                                            <div class="bonus" v-if="ele.reward_money && index === 0">
                                                奖金<span class="bonus-money">{{ ele.reward_money }}</span>元
                                            </div>
                                            <div class="sales-revenue">
                                                <span class="lable">{{
                                                        hanldSaleTitle(ele.job_type, ele.rank_type)
                                                    }}</span>
                                                <span class="value">{{
                                                        hanldMonely(item.rank_value, ele.rank_type)
                                                    }}</span>
                                            </div>
                                            <div class="last-rank escape-success"
                                                 v-if="(ele.rank.length - 1  === index) && item.status">
                                                成功逃离末尾
                                            </div>
                                            <div class="last-rank"
                                                 v-if="(ele.rank.length - 1  === index) && !item.status">
                                                未逃离末尾
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--滚动控制按钮-->
                            <div
                                class="scroll-toggle-btn"
                                @click="toggleScroll(ele)"
                                v-if="ele.bannerType === 'poster' && ele.rank?.length > 4"
                            >
                                {{ isAutoScroll ? '停止滚动' : '开启滚动' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!--pk图-->
                <div
                    :class="['pk-poster', changeBanner === ele.bannerId && ele.bannerType === 'pk' ? 'leaderboard-card-change' : 'hide']">
                    <div class="pk-bg-img-box">
                        <img :src="hanldValue(ele, 'background_url_abs')" alt="">
                    </div>
                    <div class="pk-top">
                        <img src="../assets/pkTop.png" alt="" class="pk_top_img">
                        <div class="pk-title">
                            {{ `${hanldSaleTitle(ele.job_type, ele.rank_type)}` + '大比拼' }}
                        </div>
                        <div class="pk-type">
                            <img src="../assets/pkTitle.png" alt="" class="pk_top_img">
                            <div class="pk-type-title">
                                {{ ele.job_type === 1 ? '售前组' : '售后组' }}
                            </div>
                        </div>
                    </div>
                    <div class="pk-content">
                        <!-- 左侧PK对象 -->
                        <div class="pk-left">
                            <div class="pk-left-top">
                                <img src="../assets/pkLeft.png" alt="" class="pk_top_img">
                                <div class="pk-section-title">PK对象</div>
                            </div>
                            <div class="platform-group" v-for="platform in ele.platform_user" :key="platform.id">
                                <div class="platform-name">
                                    {{ platform.name + (ele.job_type == 1 ? '售前组' : '售后组') }}({{
                                        platform.users.length
                                    }}人)
                                </div>
                                <div class="platform-name-user">
                                    <div class="user-names" v-for="user in platform.users" :key="user.id">
                                        {{ user.name + ' ' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 中间头部激励 -->
                        <div class="pk-middle">
                            <div class="pk-left-top">
                                <img src="../assets/pkLeft.png" alt="" class="pk_top_img pk-middle-img">
                                <div class="pk-section-title pk-middle-title">头部激励</div>
                            </div>
                            <div class="pk-time">{{
                                    `${hanldDateScope(ele.start_date)}-${hanldDateScope(ele.end_date)}` + ' ' + hanldSaleTitle(ele.job_type, ele.rank_type)
                                }}第一名
                            </div>
                            <div class="reward-money">
                                <img src="../assets/sui-l.png" alt="" class="pk_middle_left_img">
                                <div class="reward-label">奖金</div>
                                <div class="reward-amount">{{ Math.floor(ele.reward_money) }}</div>
                                <div class="reward-unit">元</div>
                                <img src="../assets/sui-r.png" alt="" class="pk_middle_left_img">
                            </div>
                            <div class="punish-rules" v-html="hanldLine(ele.reward_rule_desc)"></div>
                        </div>

                        <!-- 右侧尾部激励 -->
                        <div class="pk-right">
                            <div class="pk-left-top">
                                <img src="../assets/pkLeft.png" alt="" class="pk_top_img">
                                <div class="pk-section-title">尾部激励</div>
                            </div>
                            <div class="pk-time">{{
                                    `${hanldDateScope(ele.start_date)}-${hanldDateScope(ele.end_date)}`
                                }}
                            </div>
                            <div class="punish-title">{{ hanldSaleTitle(ele.job_type, ele.rank_type) }}末尾第一名</div>
                            <div class="punish-desc">开大会总结</div>
                            <div class="punish-rules" v-html="hanldLine(ele.punishment_rule_desc)"></div>
                        </div>
                    </div>
                    <div class="pk-bottom">①每周公司群发布排行榜单②开大会兑现激励</div>
                </div>
            </div>
        </template>
        <div id="loading" class="loading" v-else>
            <i class="fas fa-spinner fa-spin"></i> 正在加载数据...
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import screenfull from 'screenfull'
import {saleBanner} from "@/api/rank";

export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data() {
        return {
            autoScrollTimer: null, // 存储滚动的定时器
            list: [],
            isScreenfull: false,
            uploadTime: dayjs().format("HH:mm:ss"),
            changeBanner: 0, // 默认轮播项索引
            currCountdown: 10,
            setTime: 10,
            countdownTimer: null,
            salaMap: {
                'sale_before': '售前',
                'sale_after': '售后',
                'err': ''
            },
            headerCol: 0,
            generalImg: '',
            isAutoScroll: false, // 是否滚动
            posterAutoScrollTimer: null,
        }
    },
    created() {
        this.getAllRank()
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.setTiming()
            if (screenfull.isEnabled) {
                this.isScreenfull = false;
                screenfull.on('change', this.change)
            }
        },

        hanldValue(obj, path, result = null) {
            if (obj === null || obj === undefined || obj === '') return result
            for (const e of path.split('.')) {
                obj = obj[e]
                if (obj == null || obj === '' || obj.length === 0) return result
            }
            return obj
        },

        hanldTitle(sala, type) {
            if (sala === 'sale_before') {
                return type === 1 ? '转化率' : '销售金额'
            } else if (sala === 'sale_after') {
                return type === 1 ? '挽单量' : '挽单金额'
            }
            return ''
        },

        hanldDate(date, job_type, rank_type) {
            let month = '', up = '', sale = ''
            if (date) {
                const arr = date.split('-')
                month = arr[1]
                up = arr[2] === '01' ? '上' : '下'
            }
            sale = this.hanldSaleTitle(job_type, rank_type)

            return `${month}月${up}旬${sale}PK榜`
        },

        hanldSaleTitle(job_type, rank_type) {
            let sale = ''
            if (job_type == 1) {
                sale = rank_type === 1 ? '转化率' : '销售金额'
            } else {
                sale = rank_type === 1 ? '挽单量' : '挽单金额'
            }
            return sale
        },

        hanldRank(rank) {
            const rankList = ['冠军', '第二名', '第三名', '第四名', '第五名', '第六名', '第七名', '第八名', '第九名', '第十名']
            return rankList[rank]
        },

        hanldMonely(numScore, unit) {
            // console.log('hanldMonely ', numScore, unit)
            if (unit === 1) {
                return numScore
            } else {
                let numSala = Number(numScore)
                if (numSala >= 10000) {
                    return (numSala / 10000).toFixed(1) + '万';
                } else if (numSala >= 1000) {
                    return (numSala / 1000).toFixed(1) + '千';
                } else if (numSala % 1 === 0) {
                    return numSala.toString();
                } else if (numSala < 10) {
                    return numSala.toFixed(1);
                } else {
                    return Math.round(numSala).toString();
                }
            }
        },

        hanldDateScope(date) {
            return dayjs(date).format('MM.DD')
        },

        hanldLine(val) {
            if (!val) return '';
            const splitArr = val.split('%');
            const result = splitArr.map((item, index) => {
                if (!item) return '';
                const content = index < splitArr.length - 1 ? `${item}%` : item
                return `<div style="margin-bottom: 12px; line-height:1.5">${content}</div>`;
            }).join('');
            return result || '';
        },

        getAllRank() {
            saleBanner().then(res => {
                console.log('getAllRank 所有排行', res)
                if (res.code === 20000) {
                    let listTest = []
                    let num = 0

                    const {after_sale_rank, reward_pic, sale_rank, pk_pic} = res.data

                    if (after_sale_rank.length > 0) {
                        after_sale_rank.forEach(item => {
                            const params = {
                                ...item,
                                bannerId: num,
                                bannerType: 'sale_after',
                                yesterday: dayjs().subtract(1, 'day').format('MM-DD'),
                                beforeYesterday: dayjs().subtract(2, 'day').format('MM-DD')
                            }
                            listTest.push(params)
                            num++
                        })
                    }

                    if (sale_rank.length > 0) {
                        sale_rank.forEach(item => {
                            const params = {
                                ...item,
                                bannerId: num,
                                bannerType: 'sale_before',
                                yesterday: dayjs().subtract(1, 'day').format('MM-DD'),
                                beforeYesterday: dayjs().subtract(2, 'day').format('MM-DD')
                            }
                            listTest.push(params)
                            num++
                        })
                    }

                    if (reward_pic.length > 0) {
                        reward_pic.forEach(item => {
                            // 最后一名是否成功逃离末尾
                            const lastRankIndex = item.rank.length - 1;
                            const lastRankItem = item.rank[lastRankIndex];
                            const isEscapeEnd = Number(lastRankItem.rank_value) > Number(item.escape_end_money);
                            const rankWithStatus = [...item.rank];
                            rankWithStatus[lastRankIndex] = {
                                ...lastRankItem,
                                status: isEscapeEnd // 是否成功逃离末尾
                            };
                            const params = {
                                ...item,
                                bannerId: num,
                                bannerType: 'poster',
                                rank: rankWithStatus
                            }
                            listTest.push(params)
                            num++
                        })
                        this.generalImg = reward_pic[0].background_url_abs
                    }

                    if (pk_pic && pk_pic?.length > 0) {
                        pk_pic.forEach(item => {
                            const params = {
                                ...item,
                                bannerId: num,
                                bannerType: 'pk' // 新增banner类型
                            }
                            listTest.push(params)
                            num++
                        })
                    }

                    console.log('listTest', listTest)
                    // this.list = listTest
                    this.list = [...listTest]
                }
            })
        },
        percentageToNumber(percentageString) {
            // 确保输入是字符串
            if (typeof percentageString !== 'string') {
                percentageString = String(percentageString); // 将其他类型转换为字符串
            }

            // Trim whitespace
            const trimmedString = percentageString.trim();

            // Check if the string contains a '%' character
            let result;
            if (trimmedString.endsWith('%')) {
                // Remove the '%' character and convert to a number, then divide by 100
                const numericString = trimmedString.replace('%', '');
                result = parseFloat(numericString) / 100; // 计算结果
            } else {
                // If it's a plain number string, convert it to a number (no division needed)
                result = parseFloat(trimmedString);
            }
            // 确保返回的是数字类型
            return isNaN(result) ? 0 : result; // 如果是 NaN，则返回 0
        },

        change() {
            if (screenfull.isFullscreen) {
                this.isScreenfull = true;
            } else {
                this.isScreenfull = false
            }
        },

        // 头像加载失败时的占位符
        getAvatarPlaceholder() {
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNDAiIGZpbGw9IiMyNzMzNDgiLz48cGF0aCBkPSJNNjUgNjVINDM1MzVRNTEgNjUgNTUgNjJUNjAgNTdWNDJRNjAgMzYgNTYgMzJUNCAyOEg0Mk00MyAzNUg1N1E2MyAzNSA2NyAzOVQ3MiA0MlE3MiA0OCA2OCA1MlQ1NyA1Nkg0M1EzNyA1NiAzMyA1MlQyOSA0MlEyOSAzNSAzMyAzMVQ0MyAyNyIgb3BhY2l0eT0iMC42IiBmaWxsPSIjZmZmIi8+PC9zdmc+';
        },

        screenfull() {
            if (!screenfull.isEnabled) {
                return false
            }
            screenfull.toggle();
        },

        changeBan(e) {
            console.log('changeBan', e)
            this.stopAutoScroll();
            this.stopPosterScroll();
            this.isAutoScroll = false;

            this.changeBanner = e.bannerId
            clearInterval(this.countdownTimer)
            this.setTiming(e)
        },

        setTiming(e = {}) {
            this.headerCol = Math.floor(Math.random() * 4)
            this.uploadTime = dayjs().format("HH:mm:ss")
            this.currCountdown = this.setTime

            // --- 新增：等待 DOM 更新后启动滚动 ---
            this.$nextTick(() => {

                setTimeout(() => {
                    this.initAutoScroll(e);
                }, 800)
            });
            // ----------------------------------

            this.countdownTimer = setInterval(() => {
                // ... 原有逻辑
                this.currCountdown--
                if (this.currCountdown <= 0) {
                    clearInterval(this.countdownTimer)
                    this.countdownTimer = null
                    if (this.changeBanner < this.list.length - 1) {
                        this.changeBanner++
                    } else {
                        this.changeBanner = 0
                    }
                    this.setTiming(this.list[this.changeBanner])
                }
            }, 1000)
        },
        initAutoScroll(e) {

            // 1. 清除旧的定时器
            this.stopAutoScroll();

            // 新需求：如果当前是海报，则不启动滚动
            console.log(e)
            // if (e.bannerType === 'poster' && !this.isAutoScroll) {
            //     return;
            // }

            // 2. 获取当前显示的容器
            // 这里的 changeBanner 是你当前选中的 bannerId
            // const refName = e.bannerType === 'poster' ? "scrollRefPoster" + this.changeBanner : 'scrollRef' + this.changeBanner;
            const refName = 'scrollRef' + this.changeBanner;

            const containerArray = this.$refs[refName];
            // Vue 的 ref 在 v-for 中是一个数组，取第一个
            const container = containerArray ? containerArray[0] : null;

            if (!container) return;

            // 3. 重置滚动位置到顶部
            container.scrollTop = 0;

            // 4. 如果内容高度不足以滚动，则不启动
            if (container.scrollHeight <= container.clientHeight) return;

            // 5. 启动定时器
            this.autoScrollTimer = setInterval(() => {
                container.scrollTop += 5; // 每次滚动 1 像素

                // 触底判断：滚动距离 + 可视区高度 >= 总高度
                // 减去 1 像素作为缓冲
                if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                    if (container.scrollTop >= container.clientHeight / 3) {
                        container.scrollTop = 0; // 回到顶部实现循环
                    } else {
                        container.scrollTop = 0; // 回到顶部实现循环
                        this.stopAutoScroll();
                    }
                }

                // if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                //   container.scrollTop = 0; // 回到顶部实现循环
                // }
            }, 30); // 40ms 滚动一次，若觉得慢可以改为 30
        },

        stopAutoScroll() {
            if (this.autoScrollTimer) {
                clearInterval(this.autoScrollTimer);
                this.autoScrollTimer = null;
            }
        },

        toggleScroll(ele) {
            const container = this.$refs['scrollRefPoster' + ele.bannerId]?.[0];
            if (!container) return;

            // 停止所有定时器
            this.stopAutoScroll();
            this.stopPosterScroll();

            // 切换状态（class 会自动响应）
            this.isAutoScroll = !this.isAutoScroll;

            if (this.isAutoScroll) {
                // 开启滚动：class 已去掉 no-scroll，容器恢复固定高度+overflow:auto
                this.$nextTick(() => {
                    this.startPosterScroll(container);
                });
            } else {
                // 关闭滚动：class 自动加上 no-scroll，无需额外操作
                container.scrollTop = 0;
            }
        },

        startPosterScroll(container) {
            container.scrollTop = 0;
            if (container.scrollHeight <= container.clientHeight) return; // 内容不足不滚动

            this.posterScrollTimer = setInterval(() => {
                container.scrollTop += 5;
                if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                    container.scrollTop = 0; // 循环
                }
            }, 30);
        },

        stopPosterScroll() {
            if (this.posterScrollTimer) {
                clearInterval(this.posterScrollTimer);
                this.posterScrollTimer = null;
            }
        },
    }
}
</script>

<style scoped lang="scss">
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Microsoft YaHei', 'PingFang SC', 'Hiragino Sans GB', sans-serif;
}

.hello {
    background: linear-gradient(135deg, #0a0e29 0%, #1a1f4b 100%);
    color: #fff;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .loading {
        text-align: center;
        font-size: 4rem;
        padding: 80px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .list-box {
        height: 100vh;
        width: 100vw;
        position: relative;

        .bg_img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .poster {
        position: relative;
        border-radius: 0;
        overflow: hidden;
        border: none;
        transition: all 0.3s ease;
        backdrop-filter: blur(25px);
        display: flex;
        flex-direction: column;
        box-shadow: 0 35px 70px rgba(0, 0, 0, 0.4);
        height: 100vh;
        width: 100vw;

        .bg-img-box {
            position: absolute;
            background-color: #0de41f;
            width: 100%;
            height: 100%;
            font-size: 60px;
            top: 0;
            left: 0;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .poster-content {
            position: relative;
            z-index: 10;
            font-size: 60px;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;

            .left-box {
                width: 729px;
                height: 558px;
                margin: 0 100px 0 120px;

                .group-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    img {
                        width: 120px;
                        height: 254px;
                    }

                    .group {
                        width: 404px;
                        height: 461px;
                        font-family: OPPOSans, OPPOSans;
                        font-weight: bold;
                        font-size: 202px;
                        line-height: 230px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;

                        /* 如果需要兼容性更好的方案，可以使用以下方式 */
                        background: linear-gradient(270deg, #FCF9F1 0%, #FCF9F1 3%, #FCE4C7 55%, #FAB363 100%);
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                .tips {
                    margin-top: 17px;
                    width: 729px;
                    height: 80px;
                    font-family: OPPOSans, OPPOSans;
                    font-weight: 800;
                    font-size: 54px;
                    line-height: 80px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                    color: #FAB363;
                    text-shadow: 0px 6px 3px #7F0208;
                }

            }

            .right-box {
                flex: 1;
                height: 100%;
                padding-top: 100px;

                .title-box {
                    margin-left: 100px;
                    background: url('../assets/dai-t.png');
                    background-size: 100% 100%;
                    width: 704px;
                    height: 80px;
                    font-family: OPPOSans, OPPOSans;
                    font-weight: 800;
                    font-size: 50px;
                    color: #B02327;
                    line-height: 80px;
                    text-align: center;
                    margin-bottom: 20;
                }

                .show-data {
                    margin-left: 100px;
                    width: 704px;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                    font-size: 30px;
                }

                .award-list {
                    margin-top: 48px;
                    width: 896px;
                    height: 679px;
                    overflow-y: auto;
                    scrollbar-width: none;
                    /* Firefox */
                    -ms-overflow-style: none;

                    /* 确保不使用弹性收缩，否则无法触发 scrollTop 滚动 */
                    justify-content: flex-start;
                    /* 必须设置为 auto，平滑滚动(smooth)会干扰定时器的精准度 */
                    scroll-behavior: auto !important;

                    /* IE 10+ */
                    .award-item {
                        width: 821px;
                        height: 210px;
                        flex-shrink: 0;
                        position: relative;
                        margin-bottom: 24px;

                        .profile-box {
                            position: absolute;
                            width: 180px;
                            height: 210px;
                            z-index: 1;

                            .profile-img {
                                width: 180px;
                                height: 180px;
                                border-radius: 50%;
                                background-color: #eca567;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .img-box {
                                    overflow: hidden;
                                    width: 170px;
                                    height: 170px;
                                    background: #fff;
                                    border-radius: 50%;

                                    img {
                                        width: 170px;
                                        height: 170px;
                                        object-fit: cover;
                                        /* 或者使用 contain */
                                    }
                                }
                            }

                            .rank-box {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                z-index: 1;
                                width: 156px;
                                height: 60px;
                                margin-left: 12px;
                                background: linear-gradient(360deg, #FCF9F1 0%, #FAB363 100%);
                                box-shadow: 0px 6px 3px 0px #7F0208;
                                border-radius: 44px 44px 44px 44px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-family: OPPOSans, OPPOSans;
                                font-weight: bold;
                                font-size: 36px;
                                color: #B02327;
                                line-height: 36px;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }

                            .rank-color {
                            }

                        }

                        .info {
                            box-sizing: border-box;
                            position: absolute;
                            padding-left: 106px;
                            left: 100px;
                            top: 0;
                            width: 720px;
                            height: 180px;
                            background: linear-gradient(90deg, #B20108 0%, #830308 100%);
                            box-shadow: 0px 6px 3px 0px #7F0208;
                            border-radius: 12px 12px 12px 12px;
                            border: 3px solid;
                            border-image: linear-gradient(360deg, rgba(250, 179, 99, 0.5), rgba(252, 249, 241, 1), rgba(250, 179, 99, 0.5)) 3 3;
                            display: flex;
                            align-items: center;
                            gap: 30px;

                            .name {
                                width: 126px;
                                height: 42px;
                                font-family: OPPOSans, OPPOSans;
                                font-weight: 800;
                                font-size: 42px;
                                color: #FFFFFF;
                                line-height: 42px;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }

                            .line {
                                width: 3px;
                                height: 120px;
                                background: linear-gradient(to bottom,
                                    rgba(250, 179, 99, 0) 0%,
                                    rgba(252, 249, 241, 1) 50%,
                                    rgba(250, 179, 99, 0) 100%);
                            }

                            .money-box {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                width: 368px;

                                .bonus {
                                    font-family: OPPOSans, OPPOSans;
                                    font-weight: bold;
                                    font-size: 36px;
                                    text-align: left;
                                    font-style: normal;
                                    text-transform: none;
                                    /* 文字渐变 */
                                    background: linear-gradient(270deg, #FCF9F1 0%, #FAB363 100%);
                                    -webkit-background-clip: text;
                                    background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    color: transparent;

                                    /* 优化阴影 - 降低透明度避免遮住渐变 */
                                    text-shadow: 0px 6px 3px rgba(127, 2, 8, 0.4);

                                    .bonus-money {
                                        font-size: 100px;
                                    }
                                }

                                .sales-revenue {
                                    display: flex;
                                    justify-content: center;
                                    gap: 12px;
                                    width: 100%;

                                    .lable {
                                        // width: 108px;
                                        height: 36px;
                                        font-family: OPPOSans, OPPOSans;
                                        font-weight: bold;
                                        font-size: 36px;
                                        line-height: 36px;
                                        text-align: left;
                                        font-style: normal;
                                        text-transform: none;

                                        /* 文字渐变 */
                                        background: linear-gradient(270deg, #FCF9F1 0%, #FAB363 100%);
                                        -webkit-background-clip: text;
                                        background-clip: text;
                                        -webkit-text-fill-color: transparent;
                                        color: transparent;

                                        /* 优化阴影 - 降低透明度避免遮住渐变 */
                                        text-shadow: 0px 6px 3px rgba(127, 2, 8, 0.4);
                                    }

                                    .value {
                                        height: 36px;
                                        font-family: FF DIN Pro, FF DIN Pro;
                                        font-weight: bold;
                                        font-size: 40px;
                                        color: #FFFFFF;
                                        line-height: 36px;
                                        text-align: left;
                                        font-style: normal;
                                        text-transform: none;
                                    }
                                }

                                .last-rank {
                                    margin-top: 6px;
                                    font-family: OPPOSans, OPPOSans;
                                    font-weight: 800;
                                    font-style: italic;
                                    font-size: 30px;
                                    line-height: 30px;
                                    text-align: center;
                                    text-transform: none;
                                    color: #FAB363;
                                    text-shadow: 0px 6px 3px #7F0208;
                                }
                            }
                        }
                    }
                }

                .award-list-all {
                    margin-top: 48px;
                    width: 896px;
                    height: 720px;
                    overflow-y: auto;
                    scrollbar-width: none;
                    /* Firefox */
                    -ms-overflow-style: none;

                    /* 确保不使用弹性收缩，否则无法触发 scrollTop 滚动 */
                    justify-content: flex-start;
                    /* 必须设置为 auto，平滑滚动(smooth)会干扰定时器的精准度 */
                    scroll-behavior: auto !important;


                    /* IE 10+ */
                    .award-item {
                        width: 821px;
                        height: 160px;
                        flex-shrink: 0;
                        position: relative;
                        margin-bottom: 12px;

                        .profile-box {
                            position: absolute;
                            width: 140px;
                            height: 160px;
                            z-index: 1;

                            .profile-img {
                                width: 140px;
                                height: 140px;
                                border-radius: 50%;
                                background-color: #eca567;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .img-box {
                                    overflow: hidden;
                                    width: 130px;
                                    height: 130px;
                                    background: #fff;
                                    border-radius: 50%;

                                    img {
                                        width: 130px;
                                        height: 130px;
                                        object-fit: cover;
                                        /* 或者使用 contain */
                                    }
                                }
                            }

                            .rank-box {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                z-index: 1;
                                width: 120px;
                                height: 48px;
                                margin-left: 12px;
                                background: linear-gradient(360deg, #FCF9F1 0%, #FAB363 100%);
                                box-shadow: 0px 6px 3px 0px #7F0208;
                                border-radius: 44px 44px 44px 44px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                font-family: OPPOSans, OPPOSans;
                                font-weight: bold;
                                font-size: 28px;
                                line-height: 28px;
                                color: #B02327;

                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }

                            .rank-color {
                            }

                        }

                        .info {
                            box-sizing: border-box;
                            position: absolute;
                            padding-left: 80px;
                            left: 80px;
                            top: 0;
                            width: 700px;
                            height: 140px;
                            background: linear-gradient(90deg, #B20108 0%, #830308 100%);
                            box-shadow: 0px 6px 3px 0px #7F0208;
                            border-radius: 12px 12px 12px 12px;
                            border: 3px solid;
                            border-image: linear-gradient(360deg, rgba(250, 179, 99, 0.5), rgba(252, 249, 241, 1), rgba(250, 179, 99, 0.5)) 3 3;
                            display: flex;
                            align-items: center;
                            gap: 30px;

                            .name {
                                width: 100px;
                                height: 36px;
                                font-family: OPPOSans, OPPOSans;
                                font-weight: 800;
                                font-size: 32px;
                                line-height: 32px;
                                color: #FFFFFF;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }

                            .line {
                                width: 3px;
                                height: 100px;
                                background: linear-gradient(to bottom,
                                    rgba(250, 179, 99, 0) 0%,
                                    rgba(252, 249, 241, 1) 50%,
                                    rgba(250, 179, 99, 0) 100%);
                            }

                            .money-box {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                width: 320px;

                                .bonus {
                                    font-family: OPPOSans, OPPOSans;
                                    font-weight: bold;
                                    font-size: 28px;
                                    text-align: left;
                                    font-style: normal;
                                    text-transform: none;
                                    /* 文字渐变 */
                                    background: linear-gradient(270deg, #FCF9F1 0%, #FAB363 100%);
                                    -webkit-background-clip: text;
                                    background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    color: transparent;

                                    /* 优化阴影 - 降低透明度避免遮住渐变 */
                                    text-shadow: 0px 6px 3px rgba(127, 2, 8, 0.4);

                                    .bonus-money {
                                        font-size: 80px;
                                    }
                                }

                                .sales-revenue {
                                    display: flex;
                                    justify-content: center;
                                    gap: 12px;
                                    width: 100%;

                                    .lable {
                                        // width: 108px;
                                        height: 36px;
                                        font-family: OPPOSans, OPPOSans;
                                        font-weight: bold;
                                        font-size: 28px;
                                        line-height: 28px;
                                        text-align: left;
                                        font-style: normal;
                                        text-transform: none;

                                        /* 文字渐变 */
                                        background: linear-gradient(270deg, #FCF9F1 0%, #FAB363 100%);
                                        -webkit-background-clip: text;
                                        background-clip: text;
                                        -webkit-text-fill-color: transparent;
                                        color: transparent;

                                        /* 优化阴影 - 降低透明度避免遮住渐变 */
                                        text-shadow: 0px 6px 3px rgba(127, 2, 8, 0.4);
                                    }

                                    .value {
                                        height: 36px;
                                        font-family: FF DIN Pro, FF DIN Pro;
                                        font-weight: bold;
                                        font-size: 32px;
                                        line-height: 28px;
                                        color: #FFFFFF;
                                        text-align: left;
                                        font-style: normal;
                                        text-transform: none;
                                    }
                                }

                                .last-rank {
                                    margin-top: 6px;
                                    font-family: OPPOSans, OPPOSans;
                                    font-weight: 800;
                                    font-style: italic;
                                    font-size: 24px;
                                    line-height: 24px;
                                    text-align: center;
                                    text-transform: none;
                                    color: #FAB363;
                                    text-shadow: 0px 6px 3px #7F0208;
                                }
                            }
                        }
                    }
                }

                .award-list.no-scroll,
                .award-list-all.no-scroll {
                    height: auto !important;
                    overflow: visible !important;
                }

                .scroll-toggle-btn {
                    position: absolute;
                    bottom: 50px;
                    right: 20px;
                    z-index: 999;
                    padding: 12px 24px;
                    background: #ff6b6b;
                    color: #fff;
                    font-size: 24px;
                    font-weight: bold;
                    border-radius: 50px;
                    cursor: pointer;
                    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
                }

                .scroll-toggle-btn:hover {
                    transform: scale(1.08);
                }
            }

        }
    }


    /* 排行榜卡片 - 全屏占据全部空间 */
    .leaderboard-card {
        background: rgba(255, 255, 255, 0.08);
        border-radius: 0;
        overflow: hidden;
        border: none;
        transition: all 0.3s ease;
        // backdrop-filter: blur(25px);
        display: flex;
        flex-direction: column;
        box-shadow: 0 35px 70px rgba(0, 0, 0, 0.4);
        height: 100vh;
        width: 100vw;
        box-sizing: border-box;
    }

    .leaderboard-card-change {
        animation: fadeIn 0.8s ease-out;
    }

    .hide {
        display: none !important;
    }

    /* 不同分类的卡片样式 */
    .tm-sales-card .card-header {
        background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
    }

    .tm-after-sales-card .card-header {
        background: linear-gradient(90deg, #45b7d1, #67d9f2);
    }

    .jd-sales-card .card-header {
        background: linear-gradient(90deg, #ff9f43, #ffbe76);
    }

    .jd-after-sales-card .card-header {
        background: linear-gradient(90deg, #96ceb4, #b8e6d0);
    }

    .card-header {
        padding: 40px 50px;
        text-align: center;
        border-bottom: 8px solid rgba(255, 255, 255, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
        z-index: 1;
    }

    .card-header0 {
        background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
    }

    .card-header1 {
        background: linear-gradient(90deg, #45b7d1, #67d9f2);
    }

    .card-header2 {
        background: linear-gradient(90deg, #ff9f43, #ffbe76);
    }

    .card-header3 {
        background: linear-gradient(90deg, #96ceb4, #b8e6d0);
    }

    .card-title {
        font-size: 6rem;
        font-weight: 900;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 40px;
        letter-spacing: 3px;
        text-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
        // background: #da0707;
    }

    .card-title i {
        font-size: 6.5rem;
    }

    .leaderboard-list {
        flex: 1;
        // background: rgba(255, 255, 255, 0.08);
        padding: 20px 0;
        height: auto;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        /* 确保不使用弹性收缩，否则无法触发 scrollTop 滚动 */
        justify-content: flex-start;
        /* 必须设置为 auto，平滑滚动(smooth)会干扰定时器的精准度 */
        scroll-behavior: auto !important;
    }

    /* 隐藏滚动条让视觉更干净（可选） */
    .leaderboard-list::-webkit-scrollbar {
        display: none;
    }

    .leaderboard-list::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 20px;
    }

    .leaderboard-list::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.25);
        border-radius: 20px;
        border: 5px solid rgba(0, 0, 0, 0.1);
    }

    .leaderboard-item {
        display: flex;
        align-items: center;
        padding: 30px 40px;
        border-bottom: 4px solid rgba(255, 255, 255, 0.08);
        transition: all 0.3s ease;
        min-height: 240px;
        position: relative;
        margin: 10px 40px;
        border-radius: 25px;
        background: rgba(255, 255, 255, 0.2);
    }

    .leaderboard-item:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-3px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
    }

    .rank {
        font-size: 5.5rem;
        font-weight: 900;
        width: 160px;
        text-align: center;
        flex-shrink: 0;
        text-shadow: 3px 3px 12px rgba(0, 0, 0, 0.5);
        padding: 35px 0;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 25px;
        margin-right: 30px;
    }

    .rank-1 {
        color: #ffd700;
        text-shadow: 0 0 35px rgba(255, 215, 0, 0.7);
        background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.2));
        border: 5px solid rgba(255, 215, 0, 0.3);
    }

    .rank-2 {
        color: #c0c0c0;
        text-shadow: 0 0 30px rgba(192, 192, 192, 0.5);
        background: linear-gradient(135deg, rgba(192, 192, 192, 0.1), rgba(192, 192, 192, 0.2));
        border: 5px solid rgba(192, 192, 192, 0.3);
    }

    .rank-3 {
        color: #cd7f32;
        text-shadow: 0 0 30px rgba(205, 127, 50, 0.5);
        background: linear-gradient(135deg, rgba(205, 127, 50, 0.1), rgba(205, 127, 50, 0.2));
        border: 5px solid rgba(205, 127, 50, 0.3);
    }

    .rank-4 {
        color: #4ecdc4;
        text-shadow: 0 0 25px rgba(78, 205, 196, 0.4);
        background: linear-gradient(135deg, rgba(78, 205, 196, 0.1), rgba(78, 205, 196, 0.2));
        border: 5px solid rgba(78, 205, 196, 0.3);
    }

    .rank-5 {
        color: #45b7d1;
        text-shadow: 0 0 25px rgba(69, 183, 209, 0.4);
        background: linear-gradient(135deg, rgba(69, 183, 209, 0.1), rgba(69, 183, 209, 0.2));
        border: 5px solid rgba(69, 183, 209, 0.3);
    }

    .avatar-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 50px;
        flex-shrink: 0;
        min-width: 220px;
    }

    .avatar {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        overflow: hidden;
        border: 4px solid rgba(255, 255, 255, 0.25);
        margin-bottom: 20px;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
    }

    .avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .user-name {
        font-weight: 900;
        font-size: 3.5rem;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 250px;
        font-family: 'Microsoft YaHei', sans-serif;
        padding: 8px 20px;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 15px;
        border: 3px solid rgba(255, 255, 255, 0.1);
    }

    .user-info {
        flex: 1;
        min-width: 0;
        margin: 0 35px;
        display: flex;
        align-items: stretch;
    }

    /* 日期统计数据 + 汇总区域 - 三个区域等宽 */
    .data-stats-container {
        flex: 1;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        gap: 30px;
    }

    /* 每个区域（前天、昨天、汇总）等宽 - 各占1/3 */
    .stat-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 20px;
        border: 3px solid rgba(255, 255, 255, 0.08);
        min-height: 180px;
        transition: all 0.3s ease;
    }

    /* 汇总/挽单区域特殊样式 */
    .stat-item.average-item {
        background: rgba(255, 255, 255, 0.15);
        border: 4px solid rgba(255, 255, 255, 0.25);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2), 0 0 20px rgba(255, 255, 255, 0.1);
    }

    .stat-item:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    }

    .stat-label {
        font-size: 3rem;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 700;
        margin-bottom: 15px;
        text-align: center;
    }

    /* 汇总/挽单标签特殊样式 */
    .average-item .stat-label {
        color: rgba(255, 255, 255, 0.95);
        font-weight: 900;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    }

    .stat-value {
        font-size: 4.2rem;
        font-weight: 900;
        color: #fff;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
        text-align: center;
        //color: #48dbfb;
        text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
    }

    /* 汇总/挽单数值特殊样式 */
    .average-item .stat-value {
        font-size: 4.8rem;
        text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.6);
    }

    .percentage-value.high {
        color: #ff6b6b;
        text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
    }

    .percentage-value.medium-high {
        color: #ff9f43;
        text-shadow: 0 0 18px rgba(255, 159, 67, 0.4);
    }

    .percentage-value.medium {
        color: #feca57;
        text-shadow: 0 0 15px rgba(254, 202, 87, 0.3);
    }

    .percentage-value.medium-low {
        color: #48dbfb;
        text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
    }

    .percentage-value.low {
        color: #0abde3;
        text-shadow: 0 0 15px rgba(10, 189, 227, 0.3);
    }

    .number-value.high {
        color: #ff6b6b;
        text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
    }

    .number-value.medium-high {
        color: #ff9f43;
        text-shadow: 0 0 18px rgba(255, 159, 67, 0.4);
    }

    .number-value.medium {
        color: #feca57;
        text-shadow: 0 0 15px rgba(254, 202, 87, 0.3);
    }

    .number-value.medium-low {
        color: #48dbfb;
        text-shadow: 0 0 15px rgba(72, 219, 251, 0.3);
    }

    .number-value.low {
        color: #0abde3;
        text-shadow: 0 0 15px rgba(10, 189, 227, 0.3);
    }

    .card-footer {
        padding: 35px;
        text-align: center;
        border-top: 4px solid rgba(255, 255, 255, 0.15);
        background: rgba(0, 0, 0, 0.3);
        margin-top: auto;
        min-height: 100px;
        z-index: 1;
    }

    .update-time {
        font-size: 2.8rem;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 900;
        letter-spacing: 2px;
    }

    .empty-message {
        text-align: center;
        padding: 100px 50px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 4rem;
        line-height: 1.5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .empty-message i {
        font-size: 6rem;
        margin-bottom: 40px;
        color: #4ecdc4;
    }

    /* 动画效果 */
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(200px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .leaderboard-item {
        animation: fadeIn 0.4s ease-out;
        animation-fill-mode: both;
    }

    .leaderboard-item:nth-child(1) {
        animation-delay: 0.1s;
    }

    .leaderboard-item:nth-child(2) {
        animation-delay: 0.2s;
    }

    .leaderboard-item:nth-child(3) {
        animation-delay: 0.3s;
    }

    .leaderboard-item:nth-child(4) {
        animation-delay: 0.4s;
    }

    .leaderboard-item:nth-child(5) {
        animation-delay: 0.5s;
    }

    /* 分类指示器 */
    .category-indicator {
        position: fixed;
        bottom: 30px;
        right: 60px;
        display: flex;
        gap: 10px;
        z-index: 100;

        .category-dot {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;
        }


        .active {
            background: #4ecdc4;
            transform: scale(1.3);
            box-shadow: 0 0 15px rgba(78, 205, 196, 0.7);
        }
    }


    /* 切换计时器 */
    .timer-indicator {
        position: fixed;
        top: 30px;
        right: 30px;
        background: rgba(0, 0, 0, 0.6);
        padding: 10px 25px;
        border-radius: 10px;
        font-size: 2.5rem;
        font-weight: 700;
        color: #4ecdc4;
        border: 3px solid rgba(78, 205, 196, 0.3);
        z-index: 100;
    }

    /* 全屏按钮 */
    .fullscreen-btn {
        position: fixed;
        top: 30px;
        left: 30px;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        border: none;
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.5rem;
        z-index: 100;
        transition: all 0.3s ease;
    }

    .fullscreen-btn:hover {
        background: rgba(78, 205, 196, 0.8);
        transform: scale(1.1);
        box-shadow: 0 0 20px rgba(78, 205, 196, 0.5);
        border-radius: 50%;
    }

    /* pk图 */
    .pk-poster {
        position: relative;
        height: 100vh;
        width: 100vw;
        transition: all 0.3s ease;
        overflow: hidden;
    }

    .pk-bg-img-box {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        img {
            width: 100vw;
            height: 100vh;
            //object-fit: cover;
        }
    }

    .pk-top {
        position: relative;
        z-index: 11;
        margin-top: 20px;

        img {
            width: 160px;
            height: 90px;
        }
    }

    .pk-title {
        font-weight: bold;
        font-size: 168px;
        line-height: 168px;
        font-style: normal;
        text-transform: none;
        text-align: center;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        background: linear-gradient(180deg, #FAB363 0%, #FFD6A8 15%, #FFFCF3 50%, #FFD6A8 85%, #FAB363 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .pk-type {
        position: relative;
        text-align: center;
        margin-top: -10px;

        img {
            width: 1388px;
            height: 132px;
        }

        .pk-type-title {
            font-family: OPPOSans, OPPOSans;
            font-weight: 800;
            font-size: 50px;
            color: #B02327;
            line-height: 80px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .pk-content {
        position: relative;
        z-index: 10;
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }

    .pk-left, .pk-middle, .pk-right {
        background: linear-gradient(180deg, #A00507 0%, #E10510 100%);
        border-radius: 12px;
        border: 2px solid #A00507;
        border-image: linear-gradient(360deg, rgba(128, 3, 9, 1), rgba(255, 58, 68, 1)) 4 4;
    }

    .pk-left, .pk-right {
        width: 480px;
        height: 420px;
        text-align: center;
    }

    .pk-middle {
        width: 720px;
        height: 554px;
        margin: 12px 16px 0 16px;
    }

    .pk-left-top {
        margin-top: -8px;
        position: relative;
    }

    .pk_top_img {
        width: 240px;
        height: 60px;
    }

    .pk-middle-img {
        width: 300px;
        height: 75px;
    }

    .pk-section-title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;
        font-family: OPPOSans, OPPOSans;
        font-weight: 800;
        font-size: 32px;
        color: #B02327;
        line-height: 32px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }

    .pk-middle-title {
        font-size: 40px;
    }

    .platform-group {
        margin-top: 20px;
    }

    .platform-name {
        margin-bottom: 20px;
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 24px;
        color: #FFEDD3;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }

    .platform-name-user {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 14px;
    }

    .user-names {
        margin-bottom: 6px;
        font-family: OPPOSans, OPPOSans;
        font-weight: 800;
        font-size: 26px;
        line-height: 26px;
        letter-spacing: 1px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(180deg, #FFFCF3 0%, #FAB363 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .pk-time {
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 36px;
        color: #FFEDD3;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(180deg, #FFFCF3 0%, #FAB363 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: 84px;
        margin-bottom: 20px;
    }

    .reward-money {
        display: flex;
        align-items: self-end;
        justify-content: space-around;
        margin-bottom: 40px;
        box-sizing: border-box;
        padding: 0 25px;

        .pk_middle_left_img {
            width: 50px;
            height: 117px;
        }

        .reward-label, .reward-amount, .reward-unit {
            font-family: OPPOSans, OPPOSans;
            font-weight: 500;
            font-size: 45px;
            color: #FFEDD3;
            line-height: 45px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            background: linear-gradient(180deg, #FFFCF3 0%, #FAB363 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .reward-amount {
            font-weight: 800;
            font-size: 150px;
            line-height: 140px;
        }
    }

    .reward-rules, .punish-rules {
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 24px;
        color: #FFEDD3;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
    }

    .punish-title {
        font-family: OPPOSans, OPPOSans;
        font-weight: 800;
        font-size: 36px;
        line-height: 36px;
        letter-spacing: 2px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(180deg, #FFFCF3 0%, #FAB363 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .punish-desc {
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 20px;
        color: #FFEDD3;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 12px 0 32px 0;
    }

    .pk-bottom {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 35px;
        left: 0;
        z-index: 20;
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 24px;
        color: #FFEDD3;
        line-height: 30px;
        font-style: normal;
        text-transform: none;
    }

    /* 响应式调整 - 针对超高分辨率 */
    @media (min-height: 1000px) {
        .card-header {
            min-height: 240px;
            padding: 50px;
        }

        .card-title {
            font-size: 7rem;
            gap: 50px;
        }

        .card-title i {
            font-size: 7.5rem;
        }

        .leaderboard-item {
            min-height: 280px;
            padding: 40px 50px;
            margin: 15px 50px;
        }

        .rank {
            font-size: 6rem;
            width: 180px;
            padding: 45px 0;
        }

        .avatar-container {
            min-width: 300px;
            margin: 0 60px;
        }

        .avatar {
            width: 150px;
            height: 150px;
            margin-bottom: 25px;
        }

        .user-name {
            font-size: 3rem;
            max-width: 280px;
        }

        .stat-label {
            font-size: 3.5rem;
        }

        .stat-value {
            font-size: 4.8rem;
        }

        .average-item .stat-value {
            font-size: 5.5rem;
        }

        .update-time {
            font-size: 3.2rem;
        }
    }

    @media (min-height: 1200px) {
        .leaderboard-item {
            min-height: 320px;
        }

        .stat-item {
            min-height: 220px;
        }

        .card-footer {
            padding: 45px;
            min-height: 120px;
        }
    }

    @media (max-width: 1200px) {
        .card-title {
            font-size: 5rem;
            gap: 30px;
        }

        .card-title i {
            font-size: 5.5rem;
        }

        .leaderboard-item {
            min-height: 200px;
            padding: 25px 30px;
            margin: 8px 30px;
        }

        .rank {
            font-size: 4.5rem;
            width: 140px;
            padding: 30px 0;
        }

        .avatar-container {
            min-width: 180px;
            margin: 0 40px;
        }

        .avatar {
            width: 130px;
            height: 130px;
        }

        .user-name {
            font-size: 3.5rem;
            max-width: 200px;
        }

        .data-stats-container {
            gap: 20px;
        }

        .stat-item {
            padding: 20px 15px;
            min-height: 150px;
        }

        .stat-label {
            font-size: 2.5rem;
        }

        .stat-value {
            font-size: 3.5rem;
        }

        .average-item .stat-value {
            font-size: 4rem;
        }

        .update-time {
            font-size: 2.5rem;
        }
    }

    /* 小屏幕适配 */
    @media (max-width: 768px) {
        .card-header {
            padding: 30px 20px;
            min-height: 150px;
        }

        .card-title {
            font-size: 4rem;
            gap: 20px;
        }

        .card-title i {
            font-size: 4.5rem;
        }

        .leaderboard-item {
            flex-direction: column;
            min-height: auto;
            padding: 30px;
            margin: 15px;
        }

        .rank {
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
            padding: 20px;
            font-size: 4rem;
        }

        .avatar-container {
            margin: 20px 0;
            min-width: auto;
        }

        .user-info {
            flex-direction: column;
            width: 100%;
            margin: 20px 0 0 0;
        }

        .data-stats-container {
            flex-direction: column;
            gap: 15px;
        }

        .stat-item {
            width: 100%;
        }
    }
}
</style>